import {Flex,Box, Text,ButtonGroup, Button, 
    Spacer, Drawer,useToast, DrawerOverlay, DrawerCloseButton,DrawerHeader, 
    DrawerBody, DrawerContent,Menu,MenuItem, MenuButton,MenuList} from '@chakra-ui/react'
import {FiChevronDown,FiChevronRight} from 'react-icons/fi'
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useState,useEffect } from 'react';
import { loggedOper as lp,userReadOnly } from '../../util/grunt';
import LokacijaView from './LokacijaView';
import GovedoToBoks from './GovedoToBoks';
import { addGovedaInBoks } from "../../util/apiLokacija";


export default function LokacijaControl({lokacijatip, _selectedid=0,data=[],parentid, onSelectItem, onSave, onRefreshMe,onDelete}) {
    //const [selected,setSelected]=useState({});
    const [state,setState]=useState({addnew:false,edit:false,selected:{id:0,sifra:"",naziv:"",parentid:0},addgoveda:false})
    const [msg,setMsg]=useState({isError:false,msg:""})
    const userCanEdit=lp.uloga==="r"?false:true;
    const toast=useToast();

    const getSelected=(_id,_data)=>{
        //{id:item.id,sifra:item.sifra,naziv:item.naziv,parentid:item.parent_id}
        const _res={
            id:0,
            sifra:"",
            naziv:"",
            parentid:0
        };
        if (_data.length>0) {
            const _idx=_data.findIndex((item)=> item.id===_id);
            if (_idx!==-1) {
            _res.id=_id;
            _res.sifra=_data[_idx].sifra;
            _res.naziv=_data[_idx].naziv;
            _res.parentid=_data[_idx].parent_id;
            }    
        }
        return _res;
    }
    

    useEffect(() => {
      setState({...state,selected:getSelected(_selectedid,data)});
    }, [data])
    
    const getLokacijaVrsta=()=>{
        let _res="Lokacije";
        if (lokacijatip==="TOV") {
            _res="Tovilišta";
        } else if (lokacijatip==="ODJ") {
            _res="Boksovi";
        }
        return _res;
    }
    

    const itemSelected=(item)=>{
        setState({...state,selected:{id:item.id,sifra:item.sifra,naziv:item.naziv,parentid:item.parentid,lokacijatip:lokacijatip}})
        onSelectItem(item.id);
    }
    
    const onAddNew=()=>{
        if (parentid!==0 || (lokacijatip==="LOK")) {
            setState({...state,addnew:true,edit:false});    
        }
        
    }

    const onAddGovedaIntoBox=()=>{
        if (parentid!==0 && (lokacijatip==="ODJ")) {
            setState({...state,addgoveda:true});    
        }
        
    }

    const addGovedaToBox=async(goveda)=>{
        if (goveda.length>0) {
           
            const _govedaid=[];
            for (let index = 0; index < goveda.length; index++) {
                _govedaid.push(goveda[index].govedo_id);
            }  
            try {
                const res=await addGovedaInBoks(state.selected.id,_govedaid)
                if (res.status===200) {
                    setMsg({...msg,isError:false,msg:"Podaci uspješno pohranjeni."})
                    setState({...state,addgoveda:false});
                    onRefreshMe();
                } else {
                    setMsg({...msg,isError:true,msg:"Greška: " + res.message})
                }
            } catch (error) {
                setMsg({...msg,isError:true,msg:error.message});
            }
        }
        
    }

    const showMessageOrError=()=>{
        if (msg.msg!=="") {
            toast({
                title:"Unos",
                status:msg.isError?"error":"success",
                description:msg.msg,
                isClosable:true,
                duration:4000,
                position:"top-right",
            });
            setMsg({...msg,msg:"",isError:false});
        }
    }
    const showAddGoveda=()=>{
        
            return (
                <Drawer placement='right' size={'full'} isOpen={state.addgoveda} onClose={()=>setState({...state,addgoveda:false})}>
                <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'sm'}>
                    <DrawerCloseButton size={'sm'} color={'white'}/>
                    <DrawerHeader fontSize={'lg'} pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        Prijava goveda u boks: {state.selected.sifra} - {state.selected.naziv}
                    </DrawerHeader>
                    <DrawerBody>
                            <GovedoToBoks bokslokacija_id={state.selected.id} onClose={()=>setState({...state,addgoveda:false})} onSave={addGovedaToBox} />
                    </DrawerBody>
                </DrawerContent>
                </Drawer>
            )
        
    }

    const onEdit=()=>{
        setState({...state,addnew:false,edit:true});
    }
    const onCancle=()=>{
        setState({...state,addnew:false,edit:false});
    }

    const onDeleteLokacija=()=>{
        onDelete(state.selected);
    }

    const onSaveData=(data)=>{
        onSave(data);
        setState({...state,addnew:false,edit:false});
    }
    const getAddEditLokacijaControl=()=>{
        if (state.addnew || state.edit) {
            let _loktipid=1;
            let _id=0;
            let _sifra="";
            let _naziv="";
           
            if (lokacijatip==="TOV") {
                _loktipid=2;
            } else if (lokacijatip==="ODJ") {
                _loktipid=3;
            }
            if (state.edit) {
                _id=state.selected.id;
                _sifra=state.selected.sifra;
                _naziv=state.selected.naziv;
           
            }
            return (
                <Drawer placement='right' size={'xs'} isOpen={true}>
                <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'sm'}>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        {getLokacijaVrsta()}
                    </DrawerHeader>
                    <DrawerBody>
                            <LokacijaView lokacijatipid={_loktipid} id={_id} sifra={_sifra} naziv={_naziv} parentid={parentid} readonly={false}
                            onCancel={onCancle} onSave={onSaveData}/>
                    </DrawerBody>
                </DrawerContent>
                </Drawer>
            )
        }
        
    }

    const showData=()=>{
        if (data!==undefined) {
        return (
            
            <Box display={'flex'} flexDir={'column'} flex={1} overflowY={'auto'}>
                {
                    
                        data.map((item,i)=>{
                            return (
                                <Flex p={'0.1rem'} color={'grunt2.700'} bg={(item.id===state.selected.id)?'gray.100':'white'} fontWeight={(item.id===state.selected.id)?'semibold':'normal'}
                                _hover={{bg:'gray.100',cursor:'pointer'}} dir={'row'} fontSize={'sm'}
                                onClick={()=>itemSelected({id:item.id,sifra:item.sifra,naziv:item.naziv,parentid:item.parent_id})} key={item.id}  
                                 >
                                    
                                    {(item.id===state.selected.id)?<FiChevronRight size={'16px'}/>:<FiChevronDown size={'16px'}/>}{item.sifra} - {item.naziv}
                                    <Spacer/>
                                    <Text fontSize={'xs'} mr={'1rem'}>{item.brgoveda}</Text>
                                </Flex>
                                //style={{backgroundColor:'red'}}>{item.naziv}</Box>
                            )
                        })
                    
            }
            </Box>
            
        )
        }
    }
  return (
    <Flex direction={'column'} flex={1} shadow={'sm'} overflowY={'auto'}>
        
        <Box flexDirection={'row'} h={'25px'} display={'flex'} bg={'grunt2.700'} color={'white'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} pl={'0.5rem'} pr={'0.5rem'} fontSize={'sm'}>
            <Text>{getLokacijaVrsta()}</Text>
            <Spacer/>
            <Text>Broj goveda</Text>
        </Box>
        <Box display={'flex'} flexDirection={'column'} flex={10} overflowY={'auto'}>
            {showData()}
        </Box>
        <Spacer/>
        <ButtonGroup pt={'0.2rem'} pb={'0.2rem'} pr={'2.5rem'} isDisabled={!userCanEdit} h={'30px'}>
            {lokacijatip!=="ODJ"?
                <Button variant={'outline'} colorScheme={'grunt2'} size='xs' onClick={onAddNew} isDisabled={userReadOnly()}>Dodaj</Button>:
                <Menu size={'sm'}>
                    <MenuButton isDisabled={userReadOnly()|| parentid===0} as={Button} rightIcon={<ChevronDownIcon />} variant={'outline'} colorScheme={'grunt2'} size={'xs'}>
                        Dodaj
                    </MenuButton>
                    <MenuList fontSize={'xs'}>
                        <MenuItem isDisabled={userReadOnly()} onClick={onAddNew}>Odjeljak (boks)</MenuItem>
                        <MenuItem isDisabled={state.selected.id===0 || userReadOnly()} onClick={onAddGovedaIntoBox}>Goveda u boks</MenuItem>
                    </MenuList>
                </Menu>
            }
            
            <Button variant={'outline'} colorScheme={'grunt2'} size='xs' onClick={onEdit} isDisabled={(state.selected.id===0) | !userCanEdit} >Uredi</Button>
            <Spacer/>
            <Button variant={'outline'} colorScheme={'red'} size='xs' onClick={onDeleteLokacija} isDisabled={(state.selected.id===0) | !userCanEdit}>Briši</Button>
        </ButtonGroup>
        {showMessageOrError()}
        
        {showAddGoveda()}
        {getAddEditLokacijaControl()}
    </Flex>
  )
}
<Box m={'0.5rem'}></Box>